import { Action } from "redux"
import { Bookmark, ResourceType } from "../../models"
import { IBookmarkButton } from "./index"

export const INITIALIZE = "BOOKMARKS_INITIALIZE"
export const SET_INITIALIZED = "BOOKMARKS_SET_INITIALIZED"

export const initializeBookmarks = (): Action => ({ type: INITIALIZE })

export const setInitialized = (): Action => ({ type: SET_INITIALIZED })

export const SET_WORKSPACE_ID = "BOOKMARKS_SET_WORKSPACE_ID"

export interface SetWorkspaceId extends Action {
    workspaceId: number
}

export const setWorkspaceId = (workspaceId: number): SetWorkspaceId => ({
    type: SET_WORKSPACE_ID,
    workspaceId,
})

export const FILTER_BOOKMARKS = "BOOKMARKS_FILTER_BOOKMARKS"
export const RECEIVE_BOOKMARKS = "BOOKMARKS_RECEIVE_BOOKMARKS"
export const REQUEST_BOOKMARKS = "BOOKMARKS_REQUEST_BOOKMARKS"

export interface BookmarkButtonIdWithBookmarkIdActions extends Action {
    bookmarks: Bookmark[]
}

export interface FilterBookmarks extends Action {
    filter: string
}

export const requestBookmarks = (): Action => ({ type: REQUEST_BOOKMARKS })

export const filterBookmarks = (filter: string): FilterBookmarks => ({
    type: FILTER_BOOKMARKS,
    filter,
})

export const receiveBookmarks = (
    bookmarks: Bookmark[],
): BookmarkButtonIdWithBookmarkIdActions => ({
    type: RECEIVE_BOOKMARKS,
    bookmarks,
})

export const INITIALIZE_BOOKMARK_BUTTON = "BOOKMARKS_INITIALIZE_BOOKMARK_BUTTON"
export const REMOVE_BOOKMARK_BUTTON = "BOOKMARKS_REMOVE_BOOKMARK_BUTTON"
export const ADD_BOOKMARK = "BOOKMARKS_ADD_BOOKMARK"
export const UNBOOKMARK = "BOOKMARKS_UNBOOKMARK"
export const RECEIVE_BOOKMARK_BUTTON_BOOKMARK_ID =
    "BOOKMARKS_RECEIVE_BOOKMARK_BUTTON_BOOKMARK_ID"

export interface InitializeBookmarkButton extends Action {
    bookmarkId?: number | null
    bookmarkButtonId: string
    parentItemId?: number | null
    resourceId: number | null
    resourceType: ResourceType
    workspaceId: number | null
    url: string
}

export interface BookmarkButtonAction extends Action {
    bookmarkButton: IBookmarkButton
}

export interface BookmarkButtonIdAction extends Action {
    bookmarkButtonId: string
}

export interface ReceiveBookmarkButtonBookmarkIdAction extends Action {
    bookmarkButtonId: string
    bookmarkId: number | null
    isLoading: boolean
}

export const initializeBookmarkButton = (
    bookmarkButtonId: string,
    bookmarkId: number | null,
    resourceType: ResourceType,
    resourceId: number | null,
    workspaceId: number | null,
    parentItemId: number | null,
    url: string,
): InitializeBookmarkButton => ({
    type: INITIALIZE_BOOKMARK_BUTTON,
    bookmarkButtonId,
    bookmarkId,
    resourceId,
    resourceType,
    workspaceId,
    parentItemId,
    url,
})

export const removeBookmarkButton = (
    bookmarkButtonId: string,
): BookmarkButtonIdAction => ({
    type: REMOVE_BOOKMARK_BUTTON,
    bookmarkButtonId,
})

export const addBookmark = (
    bookmarkButton: IBookmarkButton,
): BookmarkButtonAction => ({ type: ADD_BOOKMARK, bookmarkButton })

export const unbookmark = (
    bookmarkButton: IBookmarkButton,
): BookmarkButtonAction => ({ type: UNBOOKMARK, bookmarkButton })

export const receiveBookmarkButtonBookmarkId = (
    bookmarkButtonId: string,
    bookmarkId: number | null,
    isLoading: boolean,
): ReceiveBookmarkButtonBookmarkIdAction => ({
    type: RECEIVE_BOOKMARK_BUTTON_BOOKMARK_ID,
    bookmarkButtonId,
    bookmarkId,
    isLoading,
})

export const SAVE_BOOKMARK_TITLE = "BOOKMARKS_SAVE_BOOKMARK_TITLE"
export const RECEIVE_BOOKMARK = "BOOKMARKS_RECEIVE_BOOKMARK"
export const REMOVE_BOOKMARK = "BOOKMARKS_REMOVE_BOOKMARK"
export const RECEIVE_REMOVE_BOOKMARK = "BOOKMARKS_RECEIVE_REMOVE_BOOKMARK"

export interface BookmarkAction extends Action {
    bookmark: Bookmark
}

export interface BookmarkIdAction extends Action {
    bookmarkId: number
}

export const saveBookmarkTitle = (bookmark: Bookmark): BookmarkAction => ({
    type: SAVE_BOOKMARK_TITLE,
    bookmark,
})

export const receiveBookmark = (bookmark: Bookmark): BookmarkAction => ({
    type: RECEIVE_BOOKMARK,
    bookmark,
})

export const removeBookmark = (bookmarkId: number): BookmarkIdAction => ({
    type: REMOVE_BOOKMARK,
    bookmarkId,
})

export const receiveRemoveBookmark = (
    bookmarkId: number,
): BookmarkIdAction => ({ type: RECEIVE_REMOVE_BOOKMARK, bookmarkId })

export const mapDispatchToProps = {
    initializeBookmarks,
    setInitialized,
    setWorkspaceId,
    filterBookmarks,
    receiveBookmarks,
    requestBookmarks,
    initializeBookmarkButton,
    removeBookmarkButton,
    addBookmark,
    unbookmark,
    receiveBookmarkButtonBookmarkId,
    saveBookmarkTitle,
    receiveBookmark,
    removeBookmark,
    receiveRemoveBookmark,
}

export type DispatchProps = typeof mapDispatchToProps
